/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OnboardingStepBday } from '../models/OnboardingStepBday';
import type { OnboardingStepName } from '../models/OnboardingStepName';
import type { OnboardingStepOccupation } from '../models/OnboardingStepOccupation';
import type { OnboardingStepSex } from '../models/OnboardingStepSex';
import type { OnboardingStepTOP } from '../models/OnboardingStepTOP';
import type { Pagination } from '../models/Pagination';
import type { User } from '../models/User';
import type { UserAdd } from '../models/UserAdd';
import type { UserTgAdd } from '../models/UserTgAdd';
import type { Whitelist } from '../models/Whitelist';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Check user token
     * Check user token
     * @returns any OK
     * @throws ApiError
     */
    public static checkUserToken(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/check_token',
            errors: {
                401: `access deined`,
            },
        });
    }
    /**
     * Check refresh token
     * Check refresh token
     * @param requestBody
     * @returns any Successfully refreshed tokens
     * @throws ApiError
     */
    public static checkRefreshToken(
        requestBody: {
            refresh_token?: string;
        },
    ): CancelablePromise<{
        token?: string;
        refresh?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired refresh token`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Whitelist list
     * Print all existed whitelists
     * @returns any successful operation
     * @throws ApiError
     */
    public static listWhitelist(): CancelablePromise<{
        items?: Array<Whitelist>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/whitelist/list',
        });
    }
    /**
     * Check allowing to enter user
     * @param token access token
     * @param tgId check telegram id data
     * @param tgUser checl telegram username data
     * @returns any successful operation
     * @throws ApiError
     */
    public static checkTgUser(
        token: string,
        tgId?: number,
        tgUser?: string,
    ): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/check_telegram_user',
            query: {
                'token': token,
                'tg_id': tgId,
                'tg_user': tgUser,
            },
            errors: {
                403: `403 Forbidden`,
                404: `404 Not found`,
            },
        });
    }
    /**
     * Payment
     * Payment
     * @param token Token data
     * @param tgUser Tg username
     * @param email Email
     * @param name Name
     * @param productId Product id
     * @returns any successful operation
     * @throws ApiError
     */
    public static paymentProduct(
        token: string,
        tgUser: string,
        email: string,
        name: string,
        productId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment',
            query: {
                'token': token,
                'tg_user': tgUser,
                'email': email,
                'name': name,
                'product_id': productId,
            },
            errors: {
                400: `Invalid input`,
                404: `Not found`,
            },
        });
    }
    /**
     * add in whitelist
     * @param token Token data
     * @param tgUser Tg username
     * @returns Whitelist successful operation
     * @throws ApiError
     */
    public static createWhitelist(
        token: string,
        tgUser: string,
    ): CancelablePromise<Whitelist> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/whitelist',
            query: {
                'token': token,
                'tg_user': tgUser,
            },
        });
    }
    /**
     * Get whitelist by whitelist uuid
     * @param tgUser The name that needs to be fetched. Use user1 for testing.
     * @returns Whitelist successful operation
     * @throws ApiError
     */
    public static getWhitelistTg(
        tgUser: string,
    ): CancelablePromise<Whitelist> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/whitelist/tg/{tg_user}',
            path: {
                'tg_user': tgUser,
            },
            errors: {
                400: `Invalid uuid supplied`,
                404: `User not found`,
            },
        });
    }
    /**
     * Get whitelist by user uuid
     * @param userId The name that needs to be fetched. Use user1 for testing.
     * @returns Whitelist successful operation
     * @throws ApiError
     */
    public static getWhitelistUser(
        userId: string,
    ): CancelablePromise<Whitelist> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/whitelist/user/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                400: `Invalid uuid supplied`,
                404: `User not found`,
            },
        });
    }
    /**
     * Get whitelist by whitelist uuid
     * @param id The name that needs to be fetched. Use user1 for testing.
     * @returns Whitelist successful operation
     * @throws ApiError
     */
    public static getWhitelist(
        id: string,
    ): CancelablePromise<Whitelist> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/whitelist/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid uuid supplied`,
                404: `User not found`,
            },
        });
    }
    /**
     * Update Whitelist
     * This can only be done by the logged in user.
     * @param id The user id that need to be deleted
     * @param requestBody Update an existent user in the store
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateWhitelist(
        id: string,
        requestBody?: {
            user_id?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/whitelist/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получение PDF файла
     * Эндпоинт принимает параметр запроса filename и возвращает PDF файл, хранящийся в S3.
     *
     * @returns binary PDF файл успешно возвращён.
     * @throws ApiError
     */
    public static getTopPdf(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/top/pdf',
            errors: {
                400: `Отсутствует параметр filename.`,
                404: `Файл не найден.`,
            },
        });
    }
    /**
     * Users list
     * Print all existed users
     * @param limit limit
     * @param offset offset
     * @returns any successful operation
     * @throws ApiError
     */
    public static listUser(
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<{
        items?: Array<User>;
        pagination?: Pagination;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/list',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create user
     * This can only be done by the logged in user.
     * @param requestBody Created user object
     * @returns User successful operation
     * @throws ApiError
     */
    public static createUser(
        requestBody?: UserAdd,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Logs user into the system
     * @param email The user name for login
     * @param password The password for login in clear text
     * @returns any successful operation
     * @throws ApiError
     */
    public static loginUser(
        email?: string,
        password?: string,
    ): CancelablePromise<{
        token?: string;
        refresh?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/login',
            query: {
                'email': email,
                'password': password,
            },
            errors: {
                400: `Invalid username/password supplied`,
            },
        });
    }
    /**
     * Onboarding step one
     * @param step The onboarding step
     * @param requestBody Send information about name
     * @returns any successful operation
     * @throws ApiError
     */
    public static userOnboardingName(
        step?: number,
        requestBody?: OnboardingStepName,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboarding/name',
            query: {
                'step': step,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error update information`,
            },
        });
    }
    /**
     * Onboarding step two
     * @param step The onboarding step
     * @param requestBody Send information about sex
     * @returns any successful operation
     * @throws ApiError
     */
    public static userOnboardingSex(
        step?: number,
        requestBody?: OnboardingStepSex,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboarding/sex',
            query: {
                'step': step,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error update information`,
            },
        });
    }
    /**
     * Onboarding step three
     * @param step The onboarding step
     * @param requestBody Send information about birthday day
     * @returns any successful operation
     * @throws ApiError
     */
    public static userOnboardingBday(
        step?: number,
        requestBody?: OnboardingStepBday,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboarding/bday',
            query: {
                'step': step,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error update information`,
            },
        });
    }
    /**
     * Onboarding step four
     * @param step The onboarding step
     * @param requestBody Send information about occupation
     * @returns any successful operation
     * @throws ApiError
     */
    public static userOnboardingOccupation(
        step?: number,
        requestBody?: OnboardingStepOccupation,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboarding/Occupation',
            query: {
                'step': step,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error update information`,
            },
        });
    }
    /**
     * Onboarding step five
     * @param step The onboarding step
     * @param requestBody Send information about top of personality
     * @returns any successful operation
     * @throws ApiError
     */
    public static userOnboardingTop(
        step?: number,
        requestBody?: OnboardingStepTOP,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboarding/top',
            query: {
                'step': step,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error update information`,
            },
        });
    }
    /**
     * Onboarding step done
     * @returns any successful operation
     * @throws ApiError
     */
    public static userOnboardingDone(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/onboarding/done',
            errors: {
                400: `Error update information`,
            },
        });
    }
    /**
     * Login user through tg service
     * @param requestBody Created user object
     * @returns any successful operation
     * @throws ApiError
     */
    public static loginTgUser(
        requestBody?: UserTgAdd,
    ): CancelablePromise<{
        token?: string;
        refresh?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/telegramLogin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid username/password supplied`,
            },
        });
    }
    /**
     * Logs out current logged in user session
     * @returns any successful operation
     * @throws ApiError
     */
    public static logoutUser(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/logout',
        });
    }
    /**
     * Get user by user uuid
     * @param id The name that needs to be fetched. Use user1 for testing.
     * @returns User successful operation
     * @throws ApiError
     */
    public static getUserByIs(
        id: string,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid uuid supplied`,
                404: `User not found`,
            },
        });
    }
    /**
     * Update user
     * This can only be done by the logged in user.
     * @param id The user id that need to be deleted
     * @param requestBody Update an existent user in the store
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateUser(
        id: string,
        requestBody?: UserAdd,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
